/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_Gp_OptInputs */



/**
* | output |
* | --- |
* | "Grand Prix (position-based)" |
*
* @param {League_Standings_Gp_OptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_gp_opt = /** @type {((inputs?: League_Standings_Gp_OptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_Gp_OptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Grand Prix (basé sur la position)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grand Prix (basado en posición)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Grand Prix (baseado em posição)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grand Prix (basato sulla posizione)")
	return /** @type {LocalizedString} */ ("Grand Prix (position-based)")
});